import Filterizr from 'filterizr';

const videos = document.getElementById('indamed-videos');

if (videos && videos.classList.contains('filterable')) {
    const videoGrid = videos.querySelector('.video-grid');
    const videoFilters = videos.querySelectorAll('ul.video-categories li');
    const videoSearch = videos.querySelector('.video-search input');
    const videoItems = videos.querySelectorAll('.indamed-video');

    const filterizr = new Filterizr('.video-grid', {
        delayMode: 'alternate',
        delay: 10,
        gridItemsSelector: '.indamed-video',
        gutterPixels: 20,
        callbacks: {
            onInit: () => {
                console.log(videos.querySelectorAll('.indamed-yt-video'));
            }
        }
    });

    videoFilters.forEach(filter => {
        filter.addEventListener('click', () => {
            videoFilters.forEach(f => f.classList.remove('active'));
            filter.classList.add('active');
        });
    });

    if (document.location.hash) {
        const hash = document.location.hash.replace('#', '');

        if (hash.match(/video\-\d+/)) {
            const video = document.getElementById(hash);

            if (video) {
                video.classList.add('highlight');
                video.scrollIntoView();
            }
        }
    }

    document.addEventListener('click', e => {

        if (e.target.matches('.indamed-yt-video .yt-placeholder')) {
            e.preventDefault();

            const thumbnail = e.target;
            const videoContainer = thumbnail.parentElement;
            const videoId = videoContainer.dataset.videoId;

            const iframe = document.createElement('iframe');
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.frameBorder = '0';
            iframe.allowFullscreen = true;
            videoContainer.innerHTML = ''; // Entfernt das Thumbnail
            videoContainer.appendChild(iframe);
        }
    });
}